export interface IReplace {
    search: string;
    replace: string;
}
